export function getOrganizationBillingPath(organizationId: string): string {
  return `/org/${encodeURIComponent(organizationId)}/app/settings/billing`;
}
